// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import type { State } from "@store/reducers";
import { DashboardActivityFeedTable } from "@modules/reporting/components";
import { activityFeedDashboardList } from "@modules/reporting/selectors/dashboard/activity-feed";

type PropsFromState = $Exact<{
  activityFeedList: Array<Object>,
}>;
type OwnProps = $Exact<{
  clientId: number,
}>;

type Props = $Exact<{
  ...PropsFromState,
  ...OwnProps,
}>;

class DashboardActivityfeedSection extends React.Component<Props> {
  render() {
    if (!this.props.clientId) {
      return null;
    }

    return (
      <DashboardActivityFeedTable
        clientId={this.props.clientId}
        tableData={this.props.activityFeedList}
      />
    );
  }
}

const mapStateToProps = (state: State): PropsFromState => ({
  activityFeedList: activityFeedDashboardList(state),
});

export default compose(connect(mapStateToProps))(DashboardActivityfeedSection);
